import { D06 } from "./SalesPerSummary/D06"
import { D18 } from "./ShareByTerritories/D18"
import { D38 } from "./DistrictProductGroup/D38"
import { D24 } from "./ActualTarget/D24"
import { D23 } from "./ActualLastYear/D23"
import { D38_05 } from "./EmployeeGrowthPerformance/D38_05"
import { D38_04 } from "./EmployeeComparativeSales/D38_04"
import { D38_18 } from "./SalesPerformancePerArea/D38_18"
import { D38_24 } from "./SalesMonthlyPerArea/D38_24"

export const DistrictComparativeSalesPerf = {
  "sections": [
    D06,
    D18,
    D24,
    D38,
    D23,
    D38_04,
    D38_05,
    D38_18,
    D38_24
  ]
}